import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ContentSection from "./ContentSection";
import DefaultSpacing from "./DefaultSpacing";
import { useTranslation } from "react-i18next";
import SearchContent from "../search/SearchContent";
import SearchContextProvider from "../../context/SearchContextProvider";
import SearchField from "../search/SearchField";
import { useCmsData } from "../../hooks/useCmsData";
import { IInfoBox } from "../../cms/interfaces/IInfoBox";
import CmsInfoTile from "../../cms/cmp/CmsInfoTile";
import { useLocation } from "react-router-dom";
import ExtendableRow from "../grid/ExtendableRow";
import { Document } from "./DocumentList";

interface Props {
}

const Analyzer : React.FC<Props> = () => {
    const location = useLocation();
    const {t} = useTranslation("common");
    const [columns, setColumns] = useState([] as Array<Document>);
    const [data] = useCmsData<Array<{"_translations": Array<IInfoBox>}>>({docType: "infotile", fields: `"_translations": *[_type == "translation.metadata" && references(^._id)].translations[].value->{
        content,
        muiicon,
        language
    }`});

    useEffect(() => {
        if(columns?.length === 0) {
            setColumns([{}]);
        }
    }, [columns, setColumns]);

    return <SearchContextProvider>
        <ContentSection>
            <Typography variant="h1">{t("page.analyzer.title")}</Typography>
            <DefaultSpacing margin={{size: "medium", applyTo: "topbottom"}}>
                <Box sx={{textAlign: "center"}}>
                    <SearchField />
                </Box>
                <Box sx={{margin: '1em 0'}}>
                    {<CmsInfoTile {...data?.[0]?._translations?.find(t => location?.pathname?.startsWith(`/${t?.language}`))} />}
                </Box>
            </DefaultSpacing>
        </ContentSection>
        <ExtendableRow key={columns?.length} columns={columns?.map((sc, i) => <SearchContent file={sc} setFile={(file: Document | undefined) => {
            const newCols = [...columns];
            newCols.splice(i, 1, file??{});
            setColumns(newCols);
        } } />)} addColumn={() => {
            setColumns([...columns, {}]);
        }} removeColumn={(i) => {
            setColumns([...columns.filter((_, ci) => ci !== i)]);
        }} />
    </SearchContextProvider>
}

export default Analyzer;